export default {
    animation: {
        type: [Boolean, Object],
        default: undefined
    }, 
    autoBind: {
        type: Boolean,
        default: undefined
    }, 
    contentUrls: {
        type: Array,
        default: undefined
    }, 
    dataImageUrlField: {
        type: String,
        default: undefined
    }, 
    dataSource: {
        type: [Object, Array],
        default: undefined
    }, 
    dataSpriteCssClassField: {
        type: String,
        default: undefined
    }, 
    dataTextField: {
        type: [String, Array],
        default: undefined
    }, 
    dataUrlField: {
        type: String,
        default: undefined
    }, 
    expandMode: {
        type: String,
        default: undefined
    }, 
    loadOnDemand: {
        type: Boolean,
        default: undefined
    }, 
    messages: {
        type: Object,
        default: undefined
    }, 
    template: {
        type: [String, Function],
        default: undefined
    }, 

    // Events
    activate: Function, 
    collapse: Function, 
    contentLoad: {
        type: Function,
        default: undefined
    },  
    dataBound: {
        type: Function,
        default: undefined
    },  
    error: Function, 
    expand: Function, 
    select: Function
}


// WEBPACK FOOTER //
// ./packages/kendo-layout-vue-wrapper/src/KendoPanelBar/PanelBarProps.js